<div class="row mb-3">
    <label class="col-2 col-form-label" translate="CONFIRMATION_REPORT_TEXT_DISPLAY"></label>
    <div class="col-8">
        <pace-core-text-input [(model)]="model.reportText" [parentForm]="parentForm"></pace-core-text-input>
    </div>
</div>
<div class="row mb-3">
    <div class="col-2"></div>
    <div class="col-8">{{ model.reportText.value.length }}/{{ model.reportText.options.maxLength }}</div>
</div>
